"use strict";

var _index = require("../../../index");